import React from 'react';
import { Drawer } from '@mui/material';
import "./offcanvas.css";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';


const DrawerComponent = ({ open, onClose, title, children, drwaerStyle = null }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => {}} // Prevent closing on outside click
      ModalProps={{
        keepMounted: true,
        disableScrollLock: true,
      }}
      PaperProps={{
        sx: {
          backgroundColor: '#e6f1da',
          width: 800,
          borderTopLeftRadius: 16,
          borderBottomLeftRadius: 16,
          boxShadow: '0 2px 16px rgba(25, 118, 210, 0.10)',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <div
        className="offcanvas-container"
        style={{
          pointerEvents: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <div
          className="offcanvas-header"
          style={{
            background: '#F08B51',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px 24px',
            boxShadow: '0 2px 8px rgba(25, 118, 210, 0.08)',
            borderTopLeftRadius: 16,
            position: 'relative',
          }}
        >
          {/* Centered Title */}
          <h2
            className="offcanvas-title"
            style={{
              margin: 0,
              fontSize: 22,
              fontWeight: 600,
              letterSpacing: 0.5,
              textAlign: 'center',
              width: '100%',
            }}
          >
            {title}
          </h2>

          {/* Absolutely Positioned Close Icon */}
          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 24,
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#fff',
              transition: 'color 0.2s',
              '&:hover': {
                color: 'black',
              },
            }}
            aria-label="close"
          >
            <CloseIcon fontSize="large" />
          </IconButton>
        </div>

        {/* Content */}
        <div
          style={{
            padding: 24,
            flex: 1,
            overflowY: 'auto',
            background: '#F5F5F0',
            textWrap: 'wrap'
          }}
        >
          {children}
        </div>
      </div>
    </Drawer>

  );
};

export default DrawerComponent;
